import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "emotion-theming";
import { NewCardPciContainer, NewCardLayout, NewCardLayoutMsite, CardsPaymentOfferWrapper } from "PCI/assets/style";

import {
  ListenMessage,
  LISTEN_MESSAGE_TYPE,
  PostMessage,
  POST_MESSAGE_TYPE,
} from "services/MessageService";

import {
  validateBankCard,
  validateBankCardHash,
  validateBankOffer,
  validateCardBin,
} from "store/payment/services";

import { PciSdkConfig, PciSdkTypes, PCI_IFRAME_IDS } from "PCI/utills";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { get } from "../../logics/src/utils/helpers";
import { PAYMENT_MODES } from "constants/paymentModes";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { doCheckOffers } from "../../logics/src/utils/checkOffers";
import {
  trackBankCardBinInvalid,
  trackBankCardValidForOffer,
} from "layouts/Payment/common/dependencies/tracking";
import { getIcons, ICONS_NAMES, STATIC_CARD_IMAGES } from "helpers/utils/getIcons";
import { getPlatform } from "../../helpers/index";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { DEVICE_TYPE, TRACKING_EVENTS, ACCORDIAN, BUTTON_TYPE } from "constants/index";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { AppCallback, doCallAppCallback } from "helpers/utils/webView";
import { CLIENT_URLS, OTHER_URLS } from "constants/urls";
import { doRedirect } from "helpers/utils/redirection";
import { IconText } from "@nykaa/payment-ui/src/IconText";
import { PaymentMethodCard } from "@nykaa/payment-ui/src/PaymentMethodCard/mobile";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import { BankOfferRemoveCoupon } from "@nykaa/payment-sdk/src/CreditCard/components/BankOfferRemoveCoupon";
import { Content } from "@nykaa/payment-ui/src/Content/desktop";
import { CvvInfo } from "@nykaa/payment-sdk/src/CreditCard/components/CvvInfo/mobile";
import { CvvInfo as CvvInfoDesktop } from "@nykaa/payment-sdk/src/CreditCard/components/CvvInfo/desktop";
import { Modal } from "@nykaa/payment-ui/src/Modal";
import PCI from "PCI";
import Consent from "@nykaa/payment-sdk/src/Consent/mobile";
import ConsentDesktop from "@nykaa/payment-sdk/src/Consent/desktop";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import PaymentOffers from "layouts/PaymentOffers/Loadable";

export const NewCardPci = ({
  pciPageLoadData,
  doPayment,
  deviceType,
  setLoading,
  isAccordianOpened,
  toggleNewPaymentAccordian,
  endIcon,
  isDisabled,
  paymentScreen,
  accordian,
}: PciSdkConfig) => {
  const history = useHistory();
  const theme: Theme = useTheme();
  const platform = getPlatform();

  const paymentContext = useContext(PaymentContext);
  const errorModalContext = useContext(ErrorModalContext);
  const { applicationData } = useContext(ApplicationContext);
  const { PaymentOfferRevamp, OfferWidgitOnPaymentMethod} = useContext(ExperimentAndSwitchContext);

  const [newCardHeight, setNewCardHeight] = useState(218);
  const [showCvvInfo, setShowCvvInfo] = useState(false);
  const [showConsentSheet, setShowConsentSheet] = useState(false);
  const [payWithSecureConsentSheet, setPayWithSecureConsentSheet] = useState(false);
  const [cardDetails, setCardDetails] = useState({});
  const [bankIconUrl, setBankIconUrl] = useState("");
  const [cardMethodType, setCardMethodType] = useState("");
  const [networkTypeIconUrl, setNetworkTypeIconUrl] = useState("");
  const [offerLength, setOfferLength] = useState(0);

  // for bank offer implementation

  const cartInfo = get(paymentContext, "cartInfo");
  const cartOfferKey = get(cartInfo, "cartOfferKey");
  const paymentInfo = get(paymentContext, "paymentInfo");
  const cartRules = get(paymentContext, "offersData");
  const giftCardConfig = get(paymentContext, "giftCardInfoConfig");
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const setPciOtpInfo = get(paymentContext, "setPciOtpInfo");
  const pciOtpScreenVisible = get(paymentContext, "pciOtpScreenVisible");
  const setPciOtpScreenVisible = get(paymentContext, "setPciOtpScreenVisible");
  const paymentAmount = get(pciPageLoadData, "paymentInfo.paymentAmount");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const isCartRulesLoading = get(paymentContext, "isCartRulesLoading");
  const isApp = get(applicationData, "isApp");
  const isBeautyPlatform = applicationData?.isBeautyPlatform;
  const isBankOfferAvailable = !!cartOfferKey;
  /**
   *
   * @param deviceType string
   *
   * This function is used to get isBankOfferValidationEnabled && isBankOfferCardValidationEnabled based ond devicetype
   * i.e. mweb and dweb
   */
  const checkIsBankOfferValidForDevice = () => {
    let isBankOfferValidationEnabled = paymentInfo?.isBinHashValidationRequired || false;
    let isBankOfferCardValidationEnabled = paymentInfo?.isBinValidationRequired || false;
           
    return {
      isBankOfferValidationEnabled,
      isBankOfferCardValidationEnabled,
    };
  };

  useEffect(() => {
    if (!isCartRulesLoading && paymentAmount) {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.RELOAD,
          data: pciPageLoadData,
        },
        PCI_IFRAME_IDS.CC
      );
    }
  }, [isCartRulesLoading, paymentAmount, pciPageLoadData?.paymentInfo?.token]);

  // this useEffect is for autofocus on the card number when accodian opens
  useEffect(() => {
    PostMessage(
      {
        messageEventName: POST_MESSAGE_TYPE.ACCORDIAN_OPEN,
        data: { isAccordianOpened: isAccordianOpened, paymentScreen: paymentScreen },
      },
      PCI_IFRAME_IDS.CC
    );
  }, [isAccordianOpened, paymentScreen]);

  // this useEffect is for autofocus on the card number when accodian opens on desktop

  useEffect(() => {
    PostMessage(
      {
        messageEventName: POST_MESSAGE_TYPE.ACCORDIAN_OPEN,
        data: {
          isAccordianOpened: accordian === ACCORDIAN.CREDIT_CARD,
          paymentScreen: paymentScreen,
        },
      },
      PCI_IFRAME_IDS.CC
    );
  }, [accordian, paymentScreen]);

  const cvvInfoBottomSheetTitle = "What is a CVV?";
  const cvvInfoBottomSheetText1 =
    "Turn your card over and look at the signature box. This 3-digit code is your CVV number";
  const cvvInfoBottomSheetText2 =
    "A 4-digit number on the front, just above your credit card number is your CVV";
  const cvvInfoBottomSheetSubTitle1 = "MasterCard/ Visa/ Diners Club/Rupay";
  const cvvInfoBottomSheetSubTitle2 = "Amex Cards";
  const gotIt = "Got it";
  const cvvInfoConfig = {
    title: cvvInfoBottomSheetTitle,
    subTitle1: cvvInfoBottomSheetSubTitle1,
    subTitle2: cvvInfoBottomSheetSubTitle2,
    text1: cvvInfoBottomSheetText1,
    text2: cvvInfoBottomSheetText2,
    icon: getIcons(__PLATFORM__, ICONS_NAMES.CVV_INFO),
  };

  const title = "Credit/ Debit Card";
  const subTitle = "Visa, Mastercard, Rupay & more";
  const titleFont = theme?.typography?.subTitleLG;
  const subTitleFont = theme?.typography?.bodySmall;
  const subTitleColor = getHexToRgba(theme?.colors?.chipColor, 0.64);
  const leadingIcon = getIcons("", ICONS_NAMES.CREDIT_CARD);

  const staticCardInfoText = "WE ACCEPT";
  const staticCardInfoImage = STATIC_CARD_IMAGES;

  const KnowMoreConfig = {
    cardNotSecuredIcon: getIcons(__PLATFORM__, ICONS_NAMES.CARD_NOT_SECURED),
    submitCardNotSecured: getStringFromId(
      VERNACULAR_STRING_IDS.SUBMIT_CARD_NOT_SECURED_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.SUBMIT_CARD_NOT_SECURED_TEXT
    ),
    cardNumberDetailsIcon: getIcons(__PLATFORM__, ICONS_NAMES.CARD_NUMBER_DETAILS),
    submitCardNumberDetailsText: getStringFromId(
      VERNACULAR_STRING_IDS.SUBMIT_CARD_NUMBER_DETAILS_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.SUBMIT_CARD_NUMBER_DETAILS_TEXT
    ),
    submitConsentSubTitle: getStringFromId(
      VERNACULAR_STRING_IDS.KNOW_MORE_SUB_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.KNOW_MORE_SUB_TITLE
    ),
    submitConsentTitle: getStringFromId(
      VERNACULAR_STRING_IDS.SUBMIT_CONSENT_TITLE,
      VERNACULAR_DEFAULT_MESSAGES.SUBMIT_CONSENT_TITLE
    ),
    upgradedPaymentSecurityIcon: getIcons(__PLATFORM__, ICONS_NAMES.UPGRADED_PAYMENT_SECURITY),
    submitUpgradedPaymentSecurityText: getStringFromId(
      VERNACULAR_STRING_IDS.SUBMIT_PAYMENT_SECURITY_TEXT,
      VERNACULAR_DEFAULT_MESSAGES.SUBMIT_PAYMENT_SECURITY_TEXT
    ),
  };

  const removeCouponText = "Remove Coupon";
  const removeCouponMessage = "Want to use another payment method?";

  const cvvInfoAction = (e: any) => {
    e?.preventDefault();
    e?.stopPropagation();
    setShowCvvInfo(false);
  };

  const consentSheetAction = (e: any) => {
    e?.preventDefault();
    e?.stopPropagation();
    setShowConsentSheet(false);
    setPayWithSecureConsentSheet(false);
  };

  const SecureConsentSheetAction = (e: any, dismissConsent: boolean) => {
    e?.preventDefault();
    e?.stopPropagation();
    setPayWithSecureConsentSheet(false);

    if (dismissConsent) {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.PAY_WITHOUT_SECURE_CONSENT,
          data: false,
        },
        PCI_IFRAME_IDS.CC
      );
    } else {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.PAY_WITH_SECURE_CONSENT,
          data: true,
        },
        PCI_IFRAME_IDS.CC
      );
    }
  };

  const doPaymentHandler = (params: any) => {
    // params.giftCardConfig = giftCardConfig;
    // params.walletConfig = walletConfig;
    doPayment(PAYMENT_MODES.CREDIT_CARD, params);
  };

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_LOAD_CC, res => {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.LOAD,
          data: pciPageLoadData,
        },
        PCI_IFRAME_IDS.CC
      );
    });

    PostMessage({
      messageEventName: POST_MESSAGE_TYPE.IS_SINGLE_PAGE_CHECKOUT,
      data: false,
    }, PCI_IFRAME_IDS.CC);

    ListenMessage(LISTEN_MESSAGE_TYPE.ERROR_MESSAGE, res => {
      setLoading(false);
      openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, "");
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.BIN_ENTERED, binParams => {
      const validateCardBinParams = {
        bin: binParams?.inputCardBin,
        deviceType: binParams?.deviceType,
      };
      validateCardBin(validateCardBinParams).then(res => {
        if (res?.issuerBankIconUrl) {
          setNetworkTypeIconUrl(res?.networkTypeIconUrl);
          setBankIconUrl(res?.issuerBankIconUrl);
        }
        setCardMethodType(res?.type);
        PostMessage(
          {
            messageEventName: POST_MESSAGE_TYPE.GET_BIN_DETAILS,
            data: res,
          },
          PCI_IFRAME_IDS.CC
        );
      });
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.GET_OFFERS, offerParams => {
      validateBankOffer(offerParams).then(res => {
        let offerData: any = {
          hasOffers: false,
        };
        if (res?.eligibleOffers?.length) {
          const offer: any = doCheckOffers(
            false,
            cardMethodType.toLowerCase(),
            cartRules,
            paymentInfo,
            res?.eligibleOffers
          );
          if (offer?.hasOffers) {
            offerData = {
              discountAmountMsg: offer?.discountAmountMsg,
              discountAmount: offer?.discountAmount,
              finalOrderAmount: offer?.finalOrderAmount,
              ruleKey: offer?.ruleKey,
              hasOffers: offer?.hasOffers,
            };
          }
        }
        PostMessage(
          {
            messageEventName: POST_MESSAGE_TYPE.GET_OFFERS,
            data: offerData,
          },
          PCI_IFRAME_IDS.CC
        );
      });
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.SHOW_CONSENT_NEW, res => {
      if (res?.payWithSecuring) {
        setCardDetails({ values: res?.values });
        setPayWithSecureConsentSheet(true);
      } else {
        setShowConsentSheet(true);
      }
      // app tracking for know more click
      allTrackingHandlerForApps({ event: TRACKING_EVENTS.SAVE_CARD_KNOW_MORE, isApp });
    });
    ListenMessage(LISTEN_MESSAGE_TYPE.SAVECARD_CHECKBOX_CLICK, res => {
      // app tracking for save card checkbox click
      if (res && res.check) {
        allTrackingHandlerForApps({ event: TRACKING_EVENTS.CARD_SAVED_AS_PER_RBI, isApp });
      }
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.SHOW_CVV_INFO_BOTTOM_SHEET, res => {
      setShowCvvInfo(true);
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.CREATE_ORDER_CC, orderParams => {
      doPaymentHandler(orderParams?.values);
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.BANK_OFFER_VALIDATION, res => {
      PostMessage(
        {
          messageEventName: POST_MESSAGE_TYPE.BANK_OFFER_VALIDATE,
          data: checkIsBankOfferValidForDevice(),
        },
        PCI_IFRAME_IDS.CC
      );
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.VALIDATE_BANK_CARD_HASH_REQUEST, res => {
      if (res) {
        const params = { ...res, offerKey: cartOfferKey };
        validateBankCardHash(params).then((res: any) => {
          if (get(res, "success") === true) {
            trackBankCardValidForOffer();
          } else if (get(res, "success") === false) {
            trackBankCardBinInvalid();
          }
          PostMessage(
            {
              messageEventName: POST_MESSAGE_TYPE.VALIDATE_BANK_CARD_HASH_RESPONSE,
              data: res,
            },
            PCI_IFRAME_IDS.CC
          );
        });
      }
    });

    ListenMessage(LISTEN_MESSAGE_TYPE.VALIDATE_BANK_CARD_REQUEST, params => {
      if (params) {
        validateBankCard(params).then((res: any) => {
          if (get(res, "success") === true) {
            if (trackBankCardValidForOffer) {
              trackBankCardValidForOffer();
            }
          } else if (get(res, "success") === false) {
            if (trackBankCardBinInvalid) {
              trackBankCardBinInvalid();
            }
          }
          PostMessage(
            {
              messageEventName: POST_MESSAGE_TYPE.VALIDATE_BANK_CARD_RESPONSE,
              data: res,
            },
            PCI_IFRAME_IDS.CC
          );
        });
      }
    });
  });

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.INITIATE_PAYMENT_NEW_CARD, res => {
      setPciOtpInfo({ ...res, bankIconUrl, networkTypeIconUrl, isSavedCard: false });
      if (deviceType === DEVICE_TYPE.MOBILE) {
        doRedirect({
          url: CLIENT_URLS.PCI_OTP_PAGE,
          history,
          isClientRedirection: true,
        });
      } else {
        /** for desktop */
        setPciOtpScreenVisible(true);
      }
    });
  }, [bankIconUrl]);

  useEffect(() => {
    ListenMessage(LISTEN_MESSAGE_TYPE.RESIZE_CC, setNewCardHeight).then(cardHeight => {
      if (cardHeight) {
        setNewCardHeight(cardHeight);
      }
    });
  }, [newCardHeight]);

  const consentSheet = showConsentSheet || payWithSecureConsentSheet;
  const consentActionButtonText = payWithSecureConsentSheet ? "Secure Card and pay" : "Okay";
  const consentDismissButtonText = payWithSecureConsentSheet ? "Pay without securing card" : "";
  const consentOnActionButtonClick = payWithSecureConsentSheet
    ? (e: any) => SecureConsentSheetAction(e, false)
    : consentSheetAction;
  const consentOnDismissActionButtonClick = payWithSecureConsentSheet
    ? (e: any) => SecureConsentSheetAction(e, true)
    : () => {};

  const onRemoveCoupon = () => {
    /** @isApp check for webview */
    if (isApp) {
      doCallAppCallback({
        name: AppCallback.DO_REDIRECT_TO_CART,
        data: {},
      });
    } else {
      doRedirect({
        url: !isBeautyPlatform ? OTHER_URLS.NON_BEAUTY_PLATFORM_CART_PAGE : OTHER_URLS.CART_PAGE,
        isClientRedirection: false,
      });
    }
  };

  /**
   * function to get offerLength message.
   */
  const getOfferLengthMessaageConfig = (offerLength: number)=>{
    const config = {
      text: "",
      success: true,
      color: theme.colors.positive,
      font: theme.typography.bodySmall,
    }

    if(PaymentOfferRevamp?.experimentEnabled && offerLength){
      config.text = `${offerLength} offers available`;
    }else{
      return [];
    }

    return [config];
  }

  const common = () => {
    return (
      <NewCardLayout className={`${deviceType === DEVICE_TYPE.DESKTOP && "desktopLaypout"}`}>
        
        {cartInfo?.cartOfferMessage && (
          <IconText
            text={cartInfo?.cartOfferMessage}
            leadingIcon={getIcons("", ICONS_NAMES.ALERT_INFO)}
            color={theme.colors.blue500}
            font={theme.typography.subTitleSmall}
            theme={theme}
          />
        )}

        <NewCardPciContainer
          height={`${newCardHeight}px`}
          id={PCI_IFRAME_IDS.CC}
          sandbox="allow-scripts allow-forms allow-top-navigation allow-same-origin allow-orientation-lock allow-pointer-lock"
          src={`${process.env.PCI_ORIGIN}/cc`}
        />
        <BankOfferRemoveCoupon
          isVisible={isBankOfferAvailable}
          actionButtonText={removeCouponText}
          onActionButtonClick={onRemoveCoupon}
          removeCouponMessage={removeCouponMessage}
          theme={theme}
          buttonType={BUTTON_TYPE.SMALL}
        />
      </NewCardLayout>
    );
  };

  const msite = () => {
    return (
      <PaymentMethodCard
        title={title}
        titleFont={titleFont}
        subTitle={subTitle}
        subTitleColor={subTitleColor}
        subTitleFont={subTitleFont}
        isContentVisible={true}
        toggleAccordian={() => toggleNewPaymentAccordian(PAYMENT_MODES.CREDIT_CARD, isDisabled)}
        leadingIcon={leadingIcon}
        endIcon={endIcon}
        isDisabled={isDisabled}
        theme={theme}
        offerMessages={!isAccordianOpened ? getOfferLengthMessaageConfig(offerLength) : []}
        dataTestId="lb_paymentCC"
      >
        <>
          <NewCardLayoutMsite
            isVisible={isAccordianOpened && !isFullPaymentByGiftCard}
            noMargin={!isAccordianOpened}
          >
            {PaymentOfferRevamp?.experimentEnabled && OfferWidgitOnPaymentMethod?.switchEnabled && (
              <CardsPaymentOfferWrapper>
                <PaymentOffers
                  isVisible={true}
                  isHeaderVisible={false}
                  offersData={cartRules}
                  offerForSpecificMode={["cc", "dc"]}
                  isAutoScroll={false}
                  showCarouselDots={false}
                  setOfferLength={setOfferLength}
                  platform={platform}
                  setLoading={setLoading}
                  isToggleCardAllowed={false}
                  showOnlyEligibleOffers={true}
                  isApp={isApp}
                />
              </CardsPaymentOfferWrapper>
            )}
            {common()}
          </NewCardLayoutMsite>

          <CvvInfo
            cvvInfo={cvvInfoConfig}
            actionButtonText={gotIt}
            onActionButtonClick={cvvInfoAction}
            onBottomSheetClose={cvvInfoAction}
            onBottomSheetIconClick={cvvInfoAction}
            bottomSheetMaxHeight={65}
            bottomSheetVisible={showCvvInfo}
            bottomSheetIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
            history={history}
            theme={theme}
          />

          <Consent
            bottomSheetVisible={consentSheet}
            bottomSheetIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
            bottomSheetClose={consentSheetAction}
            bottomSheetMaxHeight={73}
            consentInfo={KnowMoreConfig}
            consentActionButtonText={consentActionButtonText}
            consentDismissButtonText={consentDismissButtonText}
            consentOnActionButtonClick={consentOnActionButtonClick}
            consentOnDismissActionButtonClick={consentOnDismissActionButtonClick}
            history={history}
            theme={theme}
          />
        </>
      </PaymentMethodCard>
    );
  };

  const desktop = () => {
    return (
      <Content
        isVisible={true}
        title={title}
        font={titleFont}
        theme={theme}
        titleHeadingLevel={3}
        dataTestId="lb_paymentCC"
      >
        <>
          {common()}
          <CvvInfoDesktop
            cvvInfo={cvvInfoConfig}
            actionButtonText={gotIt}
            onActionButtonClick={cvvInfoAction}
            isVisible={showCvvInfo}
            closeIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
            theme={theme}
          />

          <ConsentDesktop
            overlayVisible={consentSheet}
            overlayIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
            overlayClose={consentSheetAction}
            // bottomSheetMaxHeight={"73"}
            consentInfo={KnowMoreConfig}
            consentActionButtonText={consentActionButtonText}
            consentDismissButtonText={consentDismissButtonText}
            consentOnActionButtonClick={consentOnActionButtonClick}
            consentOnDismissActionButtonClick={consentOnDismissActionButtonClick}
            theme={theme}
          />

          {/* This consent sheet is for OTP screen Popup */}
          <Modal isVisible={pciOtpScreenVisible} theme={theme}>
            <PCI
              paymentContext={paymentContext}
              sdkType={PciSdkTypes.OTP}
              setLoading={setLoading}
            />
          </Modal>
        </>
      </Content>
    );
  };

  if (deviceType === DEVICE_TYPE.DESKTOP) {
    return desktop();
  } else {
    return msite();
  }
};
